import compact from 'lodash/compact';
import { getUuidPromise } from 'modules/templateEditor/common';
import { isValidEmail } from 'utils/stringHelpers';

export const cleanRecipients = (csv: string) => {
  const cleaned = csv.split(',').map((recip) => recip.trim());
  return [...new Set(compact(cleaned))];
};

export const hasOnlyValidEmails = (csv: string) => cleanRecipients(csv).every(isValidEmail);

export const extractUserIdFromUrl = (url: string) => {
  const searchString = url.split('?')[1]; // falls back to undefined
  const searchParams = new URLSearchParams(searchString); // safe if created with undefined
  return searchParams.get('userId'); // null if it doesn't exist
};

export const validateUserIds = async (userIds: string[]) => {
  const validUserIds: string[] = [];
  const invalidUserIdResponses: { uuid: string; status: number }[] = [];

  /**
   * use allSettled to allow for partial successes (valid UUIDs can succeed
   * and invalid UUIDs can be reported back to the user)
   */
  type Result = PromiseSettledResult<Awaited<Promise<string>>>;

  await Promise.allSettled(userIds.map(getUuidPromise)).then((results: Result[]) => {
    results.forEach((result: Result) => {
      if (result.status === 'fulfilled') {
        validUserIds.push(result.value);
      } else {
        // rejected
        const userId = extractUserIdFromUrl(result.reason?.response?.config?.url || ''); // null if it doesn't exist
        invalidUserIdResponses.push({
          uuid: userId || 'unknown uuid',
          status: result.reason?.response?.status || 404,
        });
      }
    });
  });

  return {
    validUserIds,
    invalidUserIdResponses,
  };
};
